export const annotate = "annotate";

export const accept_team_invitation = "accept-team-invitation";

export const manage_team = "manage-team";

export const privacy_policy =
  "https://www.postscriptmedical.com/privacy-policy";

export const terms_and_conditions =
  "https://www.postscriptmedical.com/terms-of-use";
